import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../utils/api';

interface KnowledgeState {
  documents: any[];
  loading: boolean;
  error: string | null;
}

const initialState: KnowledgeState = {
  documents: [],
  loading: false,
  error: null,
};

const knowledgeSlice = createSlice({
  name: 'knowledge',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { clearError } = knowledgeSlice.actions;
export default knowledgeSlice.reducer;